import React, { useEffect, useReducer } from "react";
import { Form, Button, Row, Col, Input, Select } from "antd";
import { withRouter, RouteComponentProps } from "react-router-dom";
import "./style.scss";
import { CountryType } from "../../BusinessPartnerDetails/types";
import { SearchStateType } from "../../SearchHome/types";
import { getSearchObjFromUrl } from "../../../utils";

const { Option } = Select;
const FormItem = Form.Item;

interface SearchBusinessPartnersProps extends RouteComponentProps {
  searchBP: (searchObj: SearchStateType) => any;
  countries: CountryType[];
}
const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const initialState = {
  name: "",
  mdmId: null,
  externalId: null,
  city: "",
  postalCode: "",
  viesNumber: "",
  country: null,
  error: false,
};
const reducer = (state: SearchStateType, action) => {
  switch (action.type) {
    case "name":
    case "city":
    case "postalCode":
    case "viesNumber": {
      return { ...state, [action.type]: action.value, error: false };
    }
    case "error": {
      return { ...state, [action.type]: action.value };
    }
    case "mdmId":
    case "externalId":
    case "country": {
      return { ...state, [action.type]: action.value || null, error: false };
    }
    case "hydrateFromUrl": {
      return { ...state, ...action.searchObj };
    }
    case "reset": {
      return initialState;
    }
    default: {
      throw new Error();
    }
  }
};
const SearchBusinessPartners = ({
  location,
  countries,
  searchBP,
}: SearchBusinessPartnersProps) => {
  const [search, dispatch] = useReducer(reducer, initialState);

  const getUrlParams = () => {
    const { searchObj } = getSearchObjFromUrl(location.search);
    dispatch({ type: "hydrateFromUrl", searchObj });
  };

  useEffect(() => {
    getUrlParams();
  }, []);

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    searchBP(search);
  };

  const resetSearch = () => {
    dispatch({ type: "reset" });
    if (location.pathname.indexOf("/search") > -1) searchBP(initialState, true);
  };

  const size = "large";
  return (
    <Form onSubmit={handleSubmit} className="bp-search">
      <h2>Search Business Partner</h2>
      <Row>
        <Col span={24}>
          <FormItem label="Name" {...formItemLayout}>
            <Input
              allowClear
              size={size}
              maxLength={50}
              placeholder="Business Partner Name"
              onChange={(e) =>
                dispatch({ type: "name", value: e.target.value })
              }
              value={search.name}
            />
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <FormItem label="MDM ID" {...formItemLayout}>
            <Input
              placeholder="MDM ID"
              size={size}
              value={search.mdmId}
              onChange={(e) =>
                dispatch({ type: "mdmId", value: e.target.value })
              }
            />
          </FormItem>
        </Col>

        <Col span={8}>
          <FormItem label="External ID" {...formItemLayout}>
            <Input
              placeholder="External ID"
              size={size}
              value={search.externalId}
              onChange={(e) =>
                dispatch({ type: "externalId", value: e.target.value })
              }
            />
          </FormItem>
        </Col>
        <Col span={8}>
          <FormItem label="VIES Number" {...formItemLayout}>
            <Input
              placeholder="VIES Number"
              size={size}
              value={search.viesNumber}
              maxLength={25}
              onChange={(e) =>
                dispatch({ type: "viesNumber", value: e.target.value })
              }
            />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <FormItem label="City" {...formItemLayout}>
            <Input
              placeholder="City"
              size={size}
              value={search.city}
              onChange={(e) =>
                dispatch({ type: "city", value: e.target.value })
              }
            />
          </FormItem>
        </Col>

        <Col span={8}>
          <FormItem label="Postal Code" {...formItemLayout}>
            <Input
              placeholder="Postal Code"
              size={size}
              value={search.postalCode}
              onChange={(e) =>
                dispatch({ type: "postalCode", value: e.target.value })
              }
            />
          </FormItem>
        </Col>

        <Col span={8}>
          <FormItem label="Country" {...formItemLayout}>
            <Select
              allowClear
              value={search.country || undefined}
              showSearch
              filterOption={(input, option) =>
                option.props.children &&
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onChange={(value: number) => dispatch({ type: "country", value })}
              placeholder="Select a country"
              size={size}
            >
              {countries &&
                countries.map((item) => {
                  return (
                    <Option value={item.coId} key={item.coId}>
                      {item.coDescription}
                    </Option>
                  );
                })}
            </Select>
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Button size={size} type="primary" icon="search" htmlType="submit">
            Search
          </Button>
          <Button size={size} type="link" onClick={resetSearch}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default withRouter(SearchBusinessPartners);
